"use strict";

var _slicedToArray = require("/codebuild/output/src073659321/src/turo-project/turo-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var core_1 = require("@zettel/core");

var EditorChildren_1 = __importDefault(require("./EditorChildren"));

var editorStyles = {
  whiteSpace: 'pre-wrap',
  WebkitUserModify: 'read-write-plaintext-only',
  WebkitLineBreak: 'after-white-space',
  overflowWrap: 'break-word',
  userSelect: 'text',
  outline: 'none'
};

var DefaultRenderBlock = function DefaultRenderBlock(props) {
  return react_1.default.createElement("div", Object.assign({}, props.htmlAttrs), props.children);
};

var Editor = function Editor(props) {
  var _editorState = props.editorState,
      _onChange = props.onChange,
      readOnly = props.readOnly,
      htmlAttrs = props.htmlAttrs,
      renderTextFragment = props.renderTextFragment,
      renderStyle = props.renderStyle,
      _props$renderBlock = props.renderBlock,
      renderBlock = _props$renderBlock === void 0 ? DefaultRenderBlock : _props$renderBlock,
      renderChildren = props.renderChildren;

  var onChange = function onChange(args) {
    _onChange(args);
  };

  var ref = react_1.useRef(null);

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isComposing = _react_1$useState2[0],
      setComposing = _react_1$useState2[1];

  var editorState = _editorState;
  react_1.useLayoutEffect(function () {
    var container = ref.current;

    if (container != null && !isComposing) {
      core_1.setDomSelection(editorState, container);
    }
  }, [editorState]);
  react_1.useLayoutEffect(function () {
    var el = ref != null ? ref.current : null;

    if (el != null) {
      var beforeinput = function beforeinput(event) {
        var newEditorState = core_1.onBeforeInput(editorState, event);

        if (newEditorState != null) {
          onChange(newEditorState);
        }
      };

      el.addEventListener('beforeinput', beforeinput);
      return function () {
        el.removeEventListener('beforeinput', beforeinput);
      };
    }
  }, [ref.current, editorState]);
  var divProps = Object.assign({}, htmlAttrs, {
    style: Object.assign({}, editorStyles),
    contentEditable: readOnly === true ? false : true
  });
  var viewState = props.viewState || react_1.useMemo(function () {
    return core_1.createViewState(editorState.list);
  }, [isComposing || editorState]);
  var children = react_1.useMemo(function () {
    return react_1.default.createElement(EditorChildren_1.default, {
      blocks: viewState.blocks,
      renderBlock: renderBlock,
      renderTextFragment: renderTextFragment,
      renderStyle: renderStyle,
      renderChildren: renderChildren
    });
  }, [viewState]);
  return react_1.default.createElement("div", Object.assign({
    onSelect: function onSelect() {
      var newEditorState = core_1.onSelectionChange(editorState);
      var start = editorState.start,
          end = editorState.end;

      if (newEditorState != null && (start !== newEditorState.start || end !== newEditorState.end) && !isComposing) {
        onChange(newEditorState);
      }
    },
    onCompositionStart: function onCompositionStart() {
      return setComposing(true);
    },
    onCompositionEnd: function onCompositionEnd() {
      onChange(core_1.onSelectionChange(editorState));
      setComposing(false);
    },
    onKeyDown: function onKeyDown(event) {
      var handled = null;

      if (props.onKeyDown != null) {
        handled = props.onKeyDown(event);
      }

      if (handled == null) {
        handled = core_1.onKeyDown(editorState, event.nativeEvent);
      }

      if (handled != null) {
        event.preventDefault();
        onChange(core_1.onSelectionChange(editorState));
        onChange(handled);
      }
    },
    suppressContentEditableWarning: true,
    onKeyUp: function onKeyUp() {},
    role: "textbox",
    autoCorrect: 'off',
    ref: ref
  }, divProps), children);
};

exports.default = Editor;